import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import DataGridCell from 'components/enhanced/data-grid/components/cell/DataGridCell';
import { AddButton } from 'components/ui';
import TenantPage from 'layouts/TenantPage';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { macroExamService } from 'shared/services';

export const MacroExams = () => {
  const translationPrefix = 'pages.macro-exams.list';
  const { t } = useTranslation();

  const columns: GridColDef[] = [
    {
      field: 'code',
      headerName: t(`global.code`),
      width: 150,
      renderCell: (params: GridRenderCellParams) => {
        const macroExam = params.row;
        return (
          <div>
            <Link to={`${macroExam.id}`}>
              <b className="text-secondary-500">{macroExam.code}</b>
            </Link>
          </div>
        );
      }
    },
    {
      field: 'description',
      headerName: t(`global.description`),
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return <DataGridCell content={params.value} />;
      }
    },
    {
      field: 'exams',
      headerName: t(`global.exams`),
      sortable: false,
      width: 350,
      valueGetter: (params) => params.value && params.value.join(', '),
      renderCell: (params: GridRenderCellParams) => {
        return <DataGridCell content={params.value} />;
      }
    }
  ];

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      menuRight={<AddButton requireTenantAdmin to="new" prefix={translationPrefix} />}>
      <EnhancedDataGrid columns={columns} service={macroExamService} />
    </TenantPage>
  );
};

export default MacroExams;
